// src/util/consoleWarn.ts
var consoleWarn = function consoleWarn(text) {
  return console.warn("\uD83D\uDEE1\uFE0FArmor: ".concat(text));
};
export { consoleWarn };